module.exports = __webpack_public_path__ + "static/img/register-background.caa9cfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/register-background.jpg
// module id = ZmZ4
// module chunks = 4